import styled from 'styled-components';

export const ContButtonActions = styled.div`
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-tooltip-open {
    color: inherit;
  }

  .ant-btn-icon-only {
    color: inherit;
  }
`;
